import React from 'react'
import { DatePicker } from 'antd';
import moment from 'moment';
import { disabledDate } from '../../Helpers/helpers';

const Datepicker = ({ format = null, value = moment(new Date()), onChange, className, size, style }) => {

    return <DatePicker
        className={className}
        onChange={onChange}
        size={size}
        style={style}
        format={format}
        value={value}
        allowClear={false}
        disabledDate={disabledDate} />

    }

export default Datepicker

